import React from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Card from '@material-ui/core/Card'
import clsx from 'clsx'

import { useProjectsFiltersStyles } from './projects-filters.styles'
import { useProjectsFilters } from '../use-projects-filters'
import { ProjectsFiltersCategories } from './projects-filters-categories'
import { ProjectsFiltersCost } from './projects-filters-cost'
import { ProjectsFiltersBuildingArea } from './projects-filters-building-area'
import { ProjectsFiltersBuildingHeight } from './projects-filters-building-height'
import { TranslationDictionary } from '@plandi/common'

type ProjectsFiltersSidebarNewProps = {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  translate?: TranslationDictionary['data']
}

export const ProjectsFiltersSidebarNew: React.FC<ProjectsFiltersSidebarNewProps> =
  ({ translate }) => {
    const classes = useProjectsFiltersStyles()

    const { bimModel, expertise, setProjectsFilters, negotiated } =
      useProjectsFilters()
    return (
      <Card className={classes.root} elevation={0}>
        <div className={classes.row}>
          <ProjectsFiltersCategories translate={translate} />
        </div>
        <div className={clsx(classes.row, classes.costRow)}>
          <ProjectsFiltersCost translate={translate} />
        </div>
        <div className={clsx(classes.row, classes.negotiatedRow)}>
          <AccordionDetails>
            <FormGroup>
              <FormControlLabel
                classes={{ label: classes.checkboxlabel }}
                control={
                  <Checkbox
                    checked={negotiated ?? false}
                    style={{ fontWeight: 500 }}
                    onChange={(_, value) =>
                      setProjectsFilters({
                        negotiated: value
                      })
                    }
                  />
                }
                label={translate?.shop['projects-page']['negotiated-price']}
              />
            </FormGroup>
          </AccordionDetails>
        </div>
        <div className={classes.row}>
          <ProjectsFiltersBuildingArea translate={translate} />
        </div>
        <div className={classes.row}>
          <ProjectsFiltersBuildingHeight translate={translate} />
        </div>
        <div className={classes.row}>
          <Accordion
            className={classes.accordion}
            classes={{ expanded: classes.accordionExpanded }}
            defaultExpanded
          >
            <AccordionSummary
              className={classes.accordionSummary}
              classes={{
                expanded: classes.accordionSummaryExpanded,
                content: classes.accordionSummaryContent
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography style={{ fontWeight: 500 }} variant="subtitle1">
                {`BIM ${translate?.shop['projects-page']['models-expertise']}`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className={classes.details}>
                <FormGroup>
                  <FormControlLabel
                    classes={{ label: classes.checkboxlabel }}
                    control={
                      <Checkbox
                        checked={bimModel ?? false}
                        style={{ fontWeight: 500 }}
                        onChange={(_, value) =>
                          setProjectsFilters({
                            bimModel: value
                          })
                        }
                      />
                    }
                    label={translate?.shop['projects-page']['have-models']}
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    classes={{ label: classes.checkboxlabel }}
                    control={
                      <Checkbox
                        checked={expertise ?? false}
                        style={{ fontWeight: 500 }}
                        onChange={(_, value) =>
                          setProjectsFilters({
                            expertise: value
                          })
                        }
                      />
                    }
                    label={translate?.shop['projects-page']['have-expertise']}
                  />
                </FormGroup>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </Card>
    )
  }
